import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
      multi: true
    }
  ]
})
export class MultiSelectDropdownComponent implements ControlValueAccessor, OnInit {

  @Input() options: string[] = [];             // Lista de opções para seleção
  @Input() formGroup!: FormGroup;              // FormGroup vindo do componente pai
  @Input() controlName!: string;               // Nome do controle para o FormControl

  selectedOptions: string[] = [];
  isOptionsVisible = false;

  get control(): FormControl {
    return this.formGroup.get(this.controlName) as FormControl;
  }

  ngOnInit() {
    if (this.control && this.control.value) {
      this.selectedOptions = this.control.value;
    }
  }

  toggleOptions() {
    this.isOptionsVisible = !this.isOptionsVisible;
  }

  onCheckboxChange(event: any) {
    const option = event.target.value;
    if (event.target.checked) {
      this.selectedOptions.push(option);
    } else {
      this.selectedOptions = this.selectedOptions.filter(o => o !== option);
    }
    this.onChange(this.selectedOptions);
    this.control.setValue(this.selectedOptions); // Atualiza o FormControl com as seleções
  }

  // ControlValueAccessor methods
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectedOptions = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
